import { render, staticRenderFns } from "./CreateRoomLockModal.vue?vue&type=template&id=2f358ead&"
import script from "./CreateRoomLockModal.vue?vue&type=script&lang=js&"
export * from "./CreateRoomLockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports